module.exports = {
      id: "ic-zoomout-light-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-zoomout-light-usage",
      toString: function () {
        return this.url;
      }
    }